import { Button, FormField, FormLayout, GridFieldGroup, Paragraph, ViewModeText } from '@expressable/syntax-ds';
import { useTranslation } from 'react-i18next';
import { AutoPCPFormType } from '../pcpSchemas';

export const ConfirmPCPDetails = ({
  PCPData,
  onDiscardPCP,
  disabled,
}: {
  PCPData: AutoPCPFormType;
  onDiscardPCP: () => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <FormLayout className="p-e32 gap-e32 mobile-d:gap-e24" variant="compact">
        <Paragraph size="md" noDefaultMargins>
          {t('directSignup.NPILookup.confirmPCP.description')}
        </Paragraph>
        <FormLayout.Fields>
          <GridFieldGroup className="gap-y-e32 mobile-d:gap-y-e24">
            <FormField label={t('directSignup.NPILookup.confirmPCP.data.fullName')} viewMode>
              <ViewModeText data-testid="firstName">{PCPData.fullName || '-'}</ViewModeText>
            </FormField>
            <FormField label={t('directSignup.NPILookup.confirmPCP.data.phone')} viewMode>
              <ViewModeText>{PCPData.phone || '-'}</ViewModeText>
            </FormField>
            <FormField label={t('directSignup.NPILookup.confirmPCP.data.address')} viewMode>
              <ViewModeText>{PCPData.office || '-'}</ViewModeText>
            </FormField>
          </GridFieldGroup>
        </FormLayout.Fields>
      </FormLayout>

      <div className="p-e32">
        <Paragraph size="md">
          {t('directSignup.NPILookup.confirmPCP.onDiscard.1')}
          <Button variant="link" onClick={onDiscardPCP} disabled={disabled} size="md">
            {t('directSignup.NPILookup.confirmPCP.onDiscard.2')}
          </Button>
        </Paragraph>
      </div>
    </>
  );
};
